module.exports = __webpack_public_path__ + "img/fi-rr-school.55b9cdb5.svg";